import React, { FC } from 'react';
import { Tooltip } from 'antd';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import BrandLogoDisplay, {
	BRAND_DISPLAY_TYPE,
} from '../brands_overview_index_page/BrandLogoDisplay';
import { isBuyerOrInternalTech } from '../../utils/AuthUtils';

const getLocationName = (location: any, currentUser: any): string => {
	const buyerName = nullSafeGet('buyerCompany.name', location);
	return isBuyerOrInternalTech(currentUser) || !buyerName
		? location.name
		: `${buyerName} - ${location.name}`;
};

export const renderLocationRecord = (location: any, currentUser: any) => {
	const name = getLocationName(location, currentUser);
	return (
		<Tooltip title={name}>
			<span>{name}</span>
		</Tooltip>
	);
};

const ServiceRequestLocationRender: FC<any> = ({ location }) => {
	return (
		<BrandLogoDisplay
			brand={nullSafeGet('brand', location)}
			displayType={BRAND_DISPLAY_TYPE.WO_CREATION}
			showPlaceholder
		/>
	);
};

export default ServiceRequestLocationRender;
